import {
  Grow,
  LinearProgress,
  List,
  ListItem,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { IconCheck, IconInfoSquareRounded } from '@tabler/icons-react';
import { SvgIcon } from '../material';
import { borderRadius } from '../theme';

type PasswordStrengthProgressProps = {
  value: string;
  messages: Array<string>;
  progress: number;
  scoreTranslation: string;
  scoreColor: 'error' | 'warning' | 'success';
};

export const PasswordStrengthProgress = ({
  value,
  messages,
  progress,
  scoreTranslation,
  scoreColor,
}: PasswordStrengthProgressProps) => {
  const color = scoreColor;

  const errorMessages = messages.map(message => (
    <ListItem key={message} sx={{ py: 0, pl: 0, display: 'list-item' }}>
      {message}
    </ListItem>
  ));

  return (
    <Grow
      in={value.length > 0}
      style={{
        transformOrigin: 'center left',
      }}
    >
      <Stack spacing={1} alignItems="end">
        <LinearProgress
          variant="determinate"
          value={Math.min(progress + value.length, 100) || 0}
          color={color}
          sx={{
            width: '100%',
            borderRadius: borderRadius('xl'),
            height: value.length > 0 ? 4 : 0,
            transition: 'height 200',
            backgroundColor: theme => theme.palette.background.default,
          }}
        />

        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="flex-end"
          sx={{
            display: value === '' ? 'none' : 'flex',
          }}
        >
          {color === 'success' && (
            <SvgIcon fontSize="small" color="success">
              <IconCheck />
            </SvgIcon>
          )}
          <Typography variant="body2" color={`${color}.main`}>
            {scoreTranslation || ''}
          </Typography>
          {color !== 'success' && errorMessages.length > 0 && (
            <Tooltip
              title={
                <List sx={{ my: 0, ml: 2.5, listStyleType: 'disc' }}>
                  {errorMessages}
                </List>
              }
            >
              <SvgIcon fontSize="small" color={color}>
                <IconInfoSquareRounded />
              </SvgIcon>
            </Tooltip>
          )}
        </Stack>
      </Stack>
    </Grow>
  );
};
